import { useMutation } from '@tanstack/react-query';
import type {
  CreateApiTokenRequestDto,
  CreateApiTokenResponseDto,
} from '../../model';
import { createApiToken } from '../requests';
import type { MfaErrorResponse } from '@/entities/mfa-identity';
import type { RequestHandlerOptions } from '@/shared/api';

export function useCreateApiToken(options: RequestHandlerOptions = {}) {
  const mutation = useMutation<
    CreateApiTokenResponseDto | MfaErrorResponse,
    Error,
    CreateApiTokenRequestDto
  >({
    mutationFn: args => createApiToken(args, options),
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
